'use client';

export const ArrowLeft = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M8.11214 16.9482L16.4314 25.3644C16.6107 25.5539 16.703 25.7756 16.7083 26.0296C16.7138 26.2836 16.6188 26.5081 16.4235 26.7032C16.2282 26.8985 16.0073 26.9974 15.7608 26.9999C15.5143 27.0027 15.2934 26.9052 15.0981 26.7074L5.34092 16.8245C5.21879 16.7005 5.13137 16.5714 5.07867 16.437C5.02622 16.3024 5 16.1546 5 15.9934C5 15.832 5.02622 15.6845 5.07867 15.551C5.13137 15.4174 5.21879 15.2886 5.34092 15.1647L15.0981 5.28174C15.2786 5.09884 15.4952 5.00498 15.7477 5.00018C16.0004 4.99537 16.2257 5.08922 16.4235 5.28174C16.6188 5.48235 16.7165 5.70814 16.7165 5.95909C16.7165 6.21005 16.6188 6.43128 16.4235 6.62279L8.11214 15.0409H26.0585C26.33 15.0409 26.5548 15.1313 26.7329 15.3119C26.911 15.4923 27 15.7198 27 15.9946C27 16.2695 26.911 16.4972 26.7329 16.6776C26.5548 16.858 26.33 16.9482 26.0585 16.9482H8.11214Z"
				fill="currentColor"
			/>
		</svg>
	);
};
